module.exports = __webpack_public_path__ + "static/3-a42679201cb89ba9fd50de9cae0dc5ba.jpg";